import React from 'react';
import { Linkedin, Mail, Heart } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  return (
    <footer className="bg-slate-900 text-white py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-bold mb-4">Joana Pestana Ramos</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">{t.footer.connect}</h3>
            <div className="flex flex-col gap-3">
              <a href="mailto:joanapestana.ramos@gmail.com" className="flex items-center gap-2 text-slate-400 hover:text-teal-400 transition-colors text-sm">
                <Mail className="w-4 h-4" />
                joanapestana.ramos@gmail.com
              </a>
              <a href="https://www.linkedin.com/in/joanapr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-slate-400 hover:text-teal-400 transition-colors text-sm">
                <Linkedin className="w-4 h-4" />
                LinkedIn Profile
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">{t.footer.expertise}</h3>
            <ul className="text-slate-400 text-sm space-y-2">
              {t.footer.expertiseList.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © 2024 Joana Pestana Ramos. {t.footer.rights}
          </p>
          <p className="flex items-center gap-2 text-slate-400 text-sm">
            {t.footer.madeWith} <Heart className="w-4 h-4 text-teal-500 fill-teal-500" /> {t.footer.and}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
